import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {PostSickDay} from '@app/core/store/actions/sick-days.actions';
import {EQORebrandColor, EQORebrandIcon} from '@quickorder/angular-web-lib';
import {ShiftPopupComponent} from '@app/core/popups/shift-popup/shift-popup.component';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
	selector: 'app-create-sick-day',
	templateUrl: './create-sick-day.component.html',
	styleUrls: ['./create-sick-day.component.scss'],
})
export class CreateSickDayComponent implements OnInit {
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;
	public form: FormGroup;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { date: string, shiftId: number },
		private store: Store<IAppState>,
		public dialogRef: MatDialogRef<ShiftPopupComponent>,
		private formBuilder: FormBuilder,
	) {
	}

	public ngOnInit(): void {
		this.initForm();
	}

	public close(): void {
		this.dialogRef.close();
	}

	public save(): void {
		this.store.dispatch(new PostSickDay({shift_id: this.data.shiftId, message: this.form.value.message}));
	}

	private initForm(): void {
		this.form = this.formBuilder.group({
			message: [null],
		});
	}

}
